<template>
    <div class="uploadImg">
        <div class="item" @click="uploadImg">
            <div v-if="!upload.img" class="item-img" :style="{
                    backgroundImage: 'url('+ upload.baseImg+ ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100%',
                    }">
            </div>
            <div v-if="upload.img">
                <img type="primary" :src="isUploading ? newImage(upload.img) : upload.img" alt="" class="item-img" />
                <div class="item-img-text" >点击重新上传</div>
            </div>
            <div class="item-img-text" v-if="!upload.img && isFail ">
                <img src="../../../assets/images/uploadfail.png"/>
                上传失败
            </div>
        </div>
        <input type="file" ref="uploadFile" accept="image/*" @change="getfile" style="display: none"/>
    </div>
</template>
<script>
import pictureCompress from 'picture-compressor'
import { Toast } from "vant";
import EXIF from 'exif-js'
import { axiosUploadExt } from "@/utils/uploadApi.js";
export default {
  name: 'UploadImg',
  props:{
    upload:{
        type: Object,
        default: ()=>{
            return {
                
            }
        }
    },
    uploadCardFrontFail: {
        type: Boolean,
        default: false
    },
    uploadCardBackFail: {
        type: Boolean,
        default: false
    },
    uploadDriverFrontFail: {
        type: Boolean,
        default: false
    },
    uploadDriverBackFail: {
        type: Boolean,
        default: false
    },
    credentialsData:{
        type: Object,
        default: ()=>{
            return {}
        }
    },
    token: {
      type: String,
      default: ''
    },
    electronicKey:{
        type: String,
        default: null
    }
  },
  data() {
    return{
      innerInApp: false,
      isUploading:false
    }
  },
  computed: {
    isFail () {
      return this.uploadCardFrontFail || this.uploadCardBackFail || this.uploadDriverFrontFail || this.uploadDriverBackFail
    },
    newImage () {
      return function(img) {
        return `data:image/png;base64,${img}`
      }
    }
  },
  mounted(){
    console.log(this.upload)
    this.innerInApp = sessionStorage.getItem('isInnerApp')
  },
  methods:{
    uploadImg() {
      if (this.innerInApp == 'true') {
        this.clientAddPhoto();
      } else {
        this.$refs.uploadFile.click();
      }
    },
    clientAddPhoto() {
      const obj = {
        action: "addCommonActionSheet",
        cancelButtonTitle: "取消",
        otherButtonTitles: ["拍一张", "从相册中选择"],
      };
      window.AmapApp.bridge.send(obj, (res) => {
        const { index } = res;
        if (index === 0) {
          this.uploadImgs("onlyCamera");
        } else if (index === 1) {
          this.uploadImgs("onlyPicture");
        }
      })
    },
    uploadImgs(type) {
      var obj = {
        action: "addPhoto",
        businessName: "test_name",
        titleText: "",
        // 'returnType': 'filePath',
        maxLength: this.imgsize === "large" ? "2000" : "750",
      };
      if (type) {
        obj[type] = true;
      }
      let self = this;
      window.AmapApp.bridge.send(obj, function (res) {
        if (!res || (res && !res.imgbase64)) return;
        console.log(res, "4444");
        let str = res.imgbase64;
        var equalIndex = str.indexOf("=");
        if (str.indexOf("=") > 0) {
          str = str.substring(0, equalIndex);
        }
        var strLength = str.length;
        var fileSize = parseInt(strLength - (strLength / 8) * 2);
        if (fileSize > 5 * 1024 * 1024) {
          self.$toast("超过最大限制5M，请重新上传");
          return;
        }
        self.base64Upload(str);
      });
    },
    getfile(e){
        var self = this;
        const file = e.target.files[0]
        self.$refs.uploadFile.value = ''
        // EXIF 用于获取图片方向，处理ios 拍照问题
        EXIF.getData(file, function() {
            const orientation = EXIF.getTag(this, 'Orientation') || 1
            self.compressImg(file, orientation)
        })
    },
    // 使用base64上传图片
    base64Upload(str) {
      const self = this;
      const toastTips = Toast.loading({
        message: "上传中...",
        forbidClick: true,
      });
      const url = this.token
        ? `/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false&token=${this.token}&domainType=200`
        : "/h5/v1/common/upload/base64?group=H5&module=H5ActiveGroup&cdn=false&domainType=200";
      axiosUploadExt({
        url: url,
        method: "post",
        headers: {
          "Content-Type": "text/plain",
        },
        data: str,
      })
        .then((res) => {
          toastTips.clear();
          if (res.code !== 1) {
            Toast.fail(res.msg);
            self.isUploadFail(this.credentialsData.key, key);
            return;
          }
          this.isUploading = true
          this.$emit("srcValue", {
            credentialsKey: this.credentialsData.key,
            data: res.data,
            pageSrc: str,
          });
        })
        .catch((err) => {
          toastTips.clear();
          this.isUploadFail(this.credentialsData.key, key);
          Toast.fail("上传失败，请重新上传");
        });
    },
      compressImg(file, orientatio){
          const self = this
          let rotate = 0
          //纠正方向 
          switch (orientatio) {
                case 1:
                rotate = 0
                break
                case 3:
                rotate = 180
                break
                case 6:
                rotate = this.electronicKey == 3 ? 0 : 90
                break
                case 8:
                rotate = -90
                break
            }
        // 进行压缩
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.onload = function(event) {
            pictureCompress({
                img: event.target.result,
                // img: this.result,
                width: 2400,
                height: 2400,
                quality: 0.8,
                rotate: rotate
            }).then(res => {
                // 返回值进行服务上传
                if ( self.innerInApp == 'true') {
                    self.$emit("uploadBase64", {
                        serveSrc: res.img.split(",")[1],
                        pageSrc: res.img,
                    });
                } else {
                    self.$emit("base64Upload", {
                        serveSrc: res.img.split(",")[1],
                        pageSrc: res.img,
                    });
                }
            }).catch(() => {
                self.$toast('上传失败，请重新上传')
            })
        }
      },
  }
}
</script>
<style lang='less' scoped>
.uploadImg{
    .item{
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: rgba(0,0,0,0.90);
        line-height: 33px;
        // margin-top:10px;
        position: relative;
        //防止图片加载不出，位置变空
        width: 321px;
        height: 201px;
    }
    .item-text{
        font-size: 24px;
        color: rgba(0,0,0,0.90);
        line-height: 33px;
        margin-bottom:10px;
    }
    .item-img{
        width: 321px;
        height: 201px;
        border-radius: 16px;
    }
    .item-img-text{
        font-family: PingFangSC-Regular;
        font-size: 28.43px;
        height: 59px;
        border-radius: 0 0 8px 8px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0,0,0,0.50);
        color: #FFFFFF;
        letter-spacing: 0;
        img{
            width: 30px;
            height: 30px;
            margin-right: 10px;
            margin-bottom: 6px;
        }
    }
}
</style>
